import { createSlice } from '@reduxjs/toolkit'

export const lockedBonus = createSlice({
    name: 'lockedBonus',
    initialState: {
        lockedBonus: [],
    },
    reducers: {
        setLockedBonus: (state, action) => ({ ...state, lockedBonus: action.payload }),
    },
})

export const { setLockedBonus } = lockedBonus.actions

export default lockedBonus.reducer
